import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import { useSelector, useDispatch } from "react-redux";
import { TopProject } from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import moment from "moment";

const TopProjectCard = () => {
  const dispatch = useDispatch();
  const companyid = window.localStorage.getItem("companyid");
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then(data => setFetchTranslationList(data));
  }, []);

  useEffect(() => {
    dispatch(TopProject(companyid));
  }, [dispatch, companyid]);

  const showTopProjects = useSelector((state) => state.user.showTopProjects);

  return (
    <>
      <div className="topProjectCard topProjectCard_Res">
        <table>
          <tr className="topRow">
            <th>
              <div>
                <span>
                  {/* Top 5 Projects */}
                  {t("Top 5 Projects")}
                </span>
                <span> | </span>
                <span>
                  {/* WEEK */}
                  {t("WEEK")}
                  <text className="ms-1">{moment().week()}</text>
                </span>
              </div>
            </th>
            <td className="topTitle">
              {/* TIME WORKED */}
              {t("TIME WORKED")}
            </td>
            <td className="topTitle">
              {/* TOTAL COST */}
              {t("TOTAL COST")}
            </td>
          </tr>
          {showTopProjects?.map((project, index) => (
            <tr key={index} className={index % 2 === 0 ? "oddRow" : ""}>
              <th>{project.projectname}</th>
              <td>{`${project.timeworked ? (Number(project.timeworked).toFixed(2)) : 0}h`}</td>
              <td>{`€ ${project.totalcost ? (Number(project.totalcost).toFixed(2)) : 0}`}</td>
            </tr>
          ))}
        </table>
      </div>
    </>
  );
};

export default TopProjectCard;
